import * as React from 'react';
import { DropdownMenuContent } from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';

const ownerDropdownContentClass = cn(
  'rounded-xl border border-charcoal-200 bg-white p-1.5',
  'shadow-[0_12px_32px_-12px_rgba(15,23,42,0.2),0_4px_8px_-4px_rgba(15,23,42,0.06)]',
  'dark:border-charcoal-700 dark:bg-charcoal-850',
  'dark:shadow-[0_16px_32px_-12px_rgba(0,0,0,0.5)]',
);

type OwnerDropdownContentProps = React.ComponentProps<typeof DropdownMenuContent>;

export function OwnerDropdownContent({ className, ...props }: OwnerDropdownContentProps) {
  return <DropdownMenuContent className={cn(ownerDropdownContentClass, className)} {...props} />;
}
